import type { FunctionComponent } from "react";

import { notEmpty } from "shared/lib/utils";

import { DefaultContentTypes } from "scmp-app/components/search/consts";
import { DropdownField } from "scmp-app/components/search/search-result-panel/refine-search/dropdown-field";
import type { ContentTypeEnum } from "scmp-app/queries/__generated__/searchArticleResultPaginationQuery.graphql";

import type { TypeOption } from "./const";
import { TypeOptions } from "./const";
import LayersIcon from "./icon-layers.svg";
import { FieldGroup, FieldLabel } from "./styles";

type TypeFieldChange = {
  articleTypeIds: string[];
  articleTypeText: string;
  contentTypes: ContentTypeEnum[];
};

type TypeValue = string[];

const buildChange = (option: TypeOption): TypeFieldChange =>
  option.isContentType
    ? {
        articleTypeIds: [],
        articleTypeText: option.text,
        contentTypes: option.value as ContentTypeEnum[],
      }
    : {
        articleTypeIds: option.value,
        articleTypeText: option.text,
        contentTypes: [],
      };

type Props = {
  articleTypeIds: string[];
  contentTypes: ContentTypeEnum[];
  onChange: (change: TypeFieldChange) => void;
};

export const TypeField: FunctionComponent<Props> = ({ articleTypeIds, contentTypes, onChange }) => {
  const selectedValue: TypeValue = notEmpty(articleTypeIds) ? articleTypeIds : contentTypes;
  const options = [
    {
      isContentType: true,
      text: "All",
      value: [...DefaultContentTypes],
    },
    ...TypeOptions,
  ];

  return (
    <FieldGroup>
      <FieldLabel>Article Type</FieldLabel>
      <DropdownField<TypeValue, TypeOption>
        icon={<LayersIcon />}
        onOptionSelect={option => onChange(buildChange(option))}
        options={options}
        placeholder="All Types"
        selectedOptionValue={selectedValue}
        withCount
      />
    </FieldGroup>
  );
};

TypeField.displayName = "TypeField";
